import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  providerFacets,
  searchSuggestions,
  cancelSearchSuggestions
} from 'store/providerSearch/actions';
import { searchSuggestionsDataSelector } from 'store/providerSearch/selectors';
import { Nullable } from 'modules/types/common';
import { Suggestion } from './types';

//
//  Hook: useProviderSearchSuggestions
//
//  Description:
//  Handles suggestions data for provider search
//

export function useProviderSearchSuggestions(): {
  init: () => void;
  get: (input: string) => void;
  data: Nullable<Suggestion[]>;
} {
  // ProviderSearch selectors
  const dispatch = useDispatch();
  const suggestions: Suggestion[] = useSelector(searchSuggestionsDataSelector);

  const [data, setData] = useState<Nullable<Suggestion[]>>(null);

  useEffect(() => {
    dispatch(providerFacets());
  }, []);

  useEffect(() => {
    if (suggestions) {
      setData(suggestions);
    }
  }, [suggestions]);

  //
  //  Method: init
  //  Description: Resets the suggestions to its initial value
  //
  const init = () => {
    setData(null);
  };

  //
  //  Method: get
  //  Description: Fetches suggestions based on the input
  //
  const get = (input: string) => {
    dispatch(cancelSearchSuggestions()); // cancels any in-flight searchSuggestion calls so we make sure we're always getting the latest results
    dispatch(searchSuggestions({ input }));
  };

  return {
    init,
    get,
    data
  };
}
